import { ProductStatus } from '@data';

// Only an archived product is "finished": a support product still has hours and sprints to report, so it
// keeps the full dashboard.
export const isProductFinished = (status?: ProductStatus): boolean => status === ProductStatus.archived;
